import * as yup from 'yup';

import { AvailableType } from '../../listItem/conf/Data.conf';

export const ActionConf = {
  schema: yup.object({
    available: yup.object().nullable().required('Available is required'),
  }),
  defaultValues: {
    available: null,
  },
  fields: [
    {
      id: 'available',
      name: 'available',
      type: 'autocomplete',
      label: 'Available',
      required: true,
      options: AvailableType,
      xs: 12,
      disableClearable: false,
    },
  ],
};
